var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaperSheet3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21C4.1 21 3.75 20.85 3.45 20.55C3.15 20.25 3 19.9 3 19.5V4.5C3 4.1 3.15 3.75 3.45 3.45C3.75 3.15 4.1 3 4.5 3H16.05L21 7.95V19.5C21 19.9 20.85 20.25 20.55 20.55C20.25 20.85 19.9 21 19.5 21H4.5ZM4.5 19.5H19.5V8.775H15.225V4.5H4.5V19.5Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2501 8.24961C8.1001 8.39961 7.9251 8.47461 7.7251 8.47461C7.5251 8.47461 7.3501 8.39961 7.2001 8.24961C7.0501 8.09961 6.9751 7.92461 6.9751 7.72461C6.9751 7.52461 7.0501 7.34961 7.2001 7.19961C7.3501 7.04961 7.5251 6.97461 7.7251 6.97461C7.9251 6.97461 8.1001 7.04961 8.2501 7.19961C8.4001 7.34961 8.4751 7.52461 8.4751 7.72461C8.4751 7.92461 8.4001 8.09961 8.2501 8.24961Z",
    fill: "#F28520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2501 12.5246C8.1001 12.6746 7.9251 12.7496 7.7251 12.7496C7.5251 12.7496 7.3501 12.6746 7.2001 12.5246C7.0501 12.3746 6.9751 12.1996 6.9751 11.9996C6.9751 11.7996 7.0501 11.6246 7.2001 11.4746C7.3501 11.3246 7.5251 11.2496 7.7251 11.2496C7.9251 11.2496 8.1001 11.3246 8.2501 11.4746C8.4001 11.6246 8.4751 11.7996 8.4751 11.9996C8.4751 12.1996 8.4001 12.3746 8.2501 12.5246Z",
    fill: "#F28520"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2501 16.7996C8.1001 16.9496 7.9251 17.0246 7.7251 17.0246C7.5251 17.0246 7.3501 16.9496 7.2001 16.7996C7.0501 16.6496 6.9751 16.4746 6.9751 16.2746C6.9751 16.0746 7.0501 15.8996 7.2001 15.7496C7.3501 15.5996 7.5251 15.5246 7.7251 15.5246C7.9251 15.5246 8.1001 15.5996 8.2501 15.7496C8.4001 15.8996 8.4751 16.0746 8.4751 16.2746C8.4751 16.4746 8.4001 16.6496 8.2501 16.7996Z",
    fill: "#F28520"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperSheet3);
export default __webpack_public_path__ + "static/media/paper-sheet-3.7d6faf20a3729a385937ae965a9f47ac.svg";
export { ForwardRef as ReactComponent };